import "./stylesSpinner.css";

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="spinner-circle"></div>
    </div>
  );
};

export default Spinner;
